module.exports = __webpack_public_path__ + "images/emoji/train.d7490d51f2aedb69a9f5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/train.png
// module id = DDy9
// module chunks = 24